import {calcPercentage} from 'helpers/common-helper';
import {PlayerLineupsUsage} from 'value-objects/player-lineups-usage';
import {FilterPositionInterface} from 'components/organisms/filter-by-position/filter-position-interface';

export function combinePlayersOnDoublePosition(units: any[], positionsOrder: string[]): object[] {
    const players = {};
    units.map((unit) => {
        const player = cp(unit);

        if (!players.hasOwnProperty(player.playerId)) {
            players[player.playerId] = player;
            return;
        }

        if ('lateSwapLineupsUsage' in player && 'lateSwapLineupsUsage' in players[player.playerId]) {
            players[player.playerId].lateSwapLineupsUsage = player.lateSwapLineupsUsage.combineUsage(
                players[player.playerId].lateSwapLineupsUsage,
            );
        }

        players[player.playerId].usedLineupsCount += player.usedLineupsCount;

        const positions = [...players[player.playerId].positionName.split('/'), ...player.positionName.split('/')];

        const sortedPositions = arrayUnique(positions).sort((a, b) => {
            return positionsOrder.indexOf(a) - positionsOrder.indexOf(b);
        });

        players[player.playerId].positionName = sortedPositions.join('/');
    });

    return Object.values(players);
}

export function calcPlayerExposure(playerLineupsQuantity, filterLineupsByPlayer, lineups) {
    const totalLineupsQuantity = filterLineupsByPlayer.hasCheckedPlayers()
        ? filterLineupsByPlayer.getLineupsQuantity()
        : lineups.getQuantity();

    return calcPercentage(totalLineupsQuantity, playerLineupsQuantity, 0);
}

export function combineOptimizedAndLateSwapUsedPlayers(optimizedUsedPlayers, lateSwapUsedPlayers) {
    function createIndex(player): string {
        return player.playerId + '-' + player.positionName;
    }

    const indexedPlayers = {};
    optimizedUsedPlayers.map((player) => {
        player.lateSwapLineupsUsage = new PlayerLineupsUsage();
        indexedPlayers[createIndex(player)] = player;
    });

    lateSwapUsedPlayers.getAllAsArr().map((player) => {
        const index = createIndex(player);

        if (index in indexedPlayers) {
            indexedPlayers[index].lateSwapLineupsUsage = player.lateSwapLineupsUsage;
        } else {
            player.usedLineupsCount = 0;

            indexedPlayers[index] = player;
        }
    });

    return Object.values(indexedPlayers);
}

export function isPlayerUsedInLineups(player, filterPosition: FilterPositionInterface) {
    const propName = getPlayerLineupsQuantityPropName(filterPosition);

    return player[propName] > 0;
}

export function getPlayerLineupsQuantityPropName(filterPosition: FilterPositionInterface) {
    let result = 'usedLineupsCount';
    if (filterPosition.isKeyFlex()) {
        result = 'usedInLineupsAsFlex';
    } else if (filterPosition.isKeySuperFlex()) {
        result = 'usedInLineupsAsSuperFlex';
    }

    return result;
}
